import axios from 'axios'

import { IGNORE_SLOW_REQUEST_CONFIG, SLOW_REQUEST_CONFIG } from '../util/operationProgressUtil'
export const INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS =
  '@contextoAplicacaoActions/INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS'
export const FOTO_USUARIO_AUTENTICADO_RECUPERADA =
  '@contextoAplicacaoActions/FOTO_USUARIO_AUTENTICADO_RECUPERADA'
export const DESCARTAR_FOTO_USUARIO_RECUPERADA =
  '@contextoAplicacaoActions/DESCARTAR_FOTO_USUARIO_RECUPERADA'
export const unidadesUrl = '/bff/'
export const axiosWrapper = axios

const getUrlfotoPessoa = (codigoPessoa) => `/bff/foto/${codigoPessoa}`

export const recuperarInformacoesContextoAplicacao = (ignorarVisao) => (dispatch) =>
  axios.get(unidadesUrl, SLOW_REQUEST_CONFIG).then((response) =>
    dispatch({
      type: INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS,
      payload: { ...response.data, ignorarVisao }
    })
  )

export const recuperarFoto = (codigoPessoa) => (dispatch) =>
  axios.get(getUrlfotoPessoa(codigoPessoa), IGNORE_SLOW_REQUEST_CONFIG).then((response) =>
    dispatch({
      type: FOTO_USUARIO_AUTENTICADO_RECUPERADA,
      payload: response.data
    })
  )
export const descartarFotoPessoaRecuperada = () => {
  return {
    type: DESCARTAR_FOTO_USUARIO_RECUPERADA
  }
}
